'use client';

import {
    AccountDrawerType,
    LegacyIcon,
    LegacyIconName,
    usePageLayout,
    useUserSession,
} from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';
import { useRouter } from 'next/navigation';

export default function LegacyHeaderPersonIcon() {
    const router = useRouter();
    const { openAccountDrawer } = usePageLayout();
    const { user } = useUserSession();

    const handleClickPersonIcon = () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- For now
        user
            ? router.push(NAVIGATION_URLS.velocity.account.aboutYou)
            : openAccountDrawer(AccountDrawerType.SIGN_IN);
    };
    return (
        <button
            type="button"
            onClick={handleClickPersonIcon}
            title="Rewards & Account"
            data-testid="legacy-header-account-link"
            className="legacy-header__person"
        >
            <LegacyIcon
                aria-hidden="true"
                name={LegacyIconName.PERSON}
                isPriority
                size={20}
            />
        </button>
    );
}
